export enum ChangeOrderStatuses {
    InProgress = 1,
    InReview,
    Submitted,
    Accepted,
    Rejected,
    Canceled,
    OnHold
}
